module.exports = __webpack_public_path__ + "img/banner_truth_or_dare.ee9017c9.png";